import { pxToRem } from '../../../../utils';
export var itemLayoutVariables = function itemLayoutVariables() {
  return {
    paddingLeft: pxToRem(20),
    paddingRight: pxToRem(18),
    columnGap: pxToRem(8),
    height: pxToRem(48)
  };
};